import { useState, useEffect } from "react";
import TicketEntryScanner from "../TicketEntryScanner";
import {useDispatch, useSelector} from "react-redux"
import {
    fetchSaveReceiptsForPayeeProduct, 
    fetchSubscribeToCreatedReceiptsForPayeeProduct, 
    fetchSubscribeToUpdatedReceiptsForPayeeProduct,
    fetchVerifyReceipt
} from "../../actions"
import {
    //the product specific functions are here
    customValidateProductReceiptTickets,
} from "../../utils/ticketUtils"
import { OBJECT_TYPE_RECEIPT } from "../../constants/receipts";

const ProductTicketEntryScanner = ({
    payeeId="",
    payeeProductId=""
}) => {
    /** 
     * Purpose: facilitate scanning of digital tickets for a given product
     * 
     * Main function: intelligently load the receipts for the specified payee product 
     * **/
    const receipts = useSelector(state => state.receipts)
    //find the last date the the receipts were loaded
    const receiptStats = receipts &&
                     receipts.loaded &&
                     receipts.loaded.payeeProductIds &&
                     receipts.loaded.payeeProductIds[payeeProductId] &&
                     typeof receipts.loaded.payeeProductIds[payeeProductId] === "object"
                     ?
                     receipts.loaded.payeeProductIds[payeeProductId]
                     :
                     {}
    const {lastCreatedAt=0, lastUpdatedAt=0, lastLoadedAt=0} = receiptStats
    //listen to the receipts created after the receipt load product 
    const [createdReceiptsListener, setCreatedReceiptsListener] = useState(()=>()=>{})
    //listen to the receipts updated/verified after the last load for this product 
    const [updatedReceiptsListener, setUpdatedReceiptsListener] = useState(()=>()=>{})
    //load all receipts for this product, on mount
    const dispatch = useDispatch()
    const listenToPayeeProductReceipts = async () => {
        //listen to products
        dispatch(fetchSaveReceiptsForPayeeProduct(payeeProductId, payeeId))
        if (lastCreatedAt){
            //listen to any receipts created after mounting
            const newCreatedReceiptsListener = await dispatch(fetchSubscribeToCreatedReceiptsForPayeeProduct(payeeProductId, payeeId, lastCreatedAt))
            setCreatedReceiptsListener(() => newCreatedReceiptsListener)
        }
        if (lastUpdatedAt) {
            //listen to any receipts updated/verified after mounting
            const newUpdatedReceiptsListener = await dispatch(fetchSubscribeToUpdatedReceiptsForPayeeProduct(payeeProductId, payeeId, lastUpdatedAt))
            setUpdatedReceiptsListener(() => newUpdatedReceiptsListener)
        }
    }
    //load receipts on mount
    useEffect(() => {
        if (payeeProductId) listenToPayeeProductReceipts()
        return () => {
            if (typeof createdReceiptsListener === "function") createdReceiptsListener()
            if (typeof updatedReceiptsListener === "function") updatedReceiptsListener()
        }
    }, [
        payeeProductId,
        lastLoadedAt
    ])
    const payeeProductReceiptsById = useSelector(state => state.receipts.payeeProductReceiptsById) 
    const handleVerify = (verificationId, scanData, objectType) => {
        if (objectType !== OBJECT_TYPE_RECEIPT) return
        dispatch(fetchVerifyReceipt(
            scanData.receiptId, 
            scanData.id,
            verificationId
        ))
    }
    return <TicketEntryScanner
                payeeId={payeeId} 
                receiptCustomValidate={(scanData, receipt) => customValidateProductReceiptTickets(scanData, receipt, payeeProductId)}
                receiptsById={payeeProductReceiptsById}
                onVerify={handleVerify}
            />
}

export default ProductTicketEntryScanner